import { Provider } from "react-redux";
import ChatComponent from "../Chat/Chat";
import store from "../../utils/store";
import { RouterProvider, createHashRouter } from "react-router-dom";
/* Semantic UI CSS is loaded via src/semantic-layer.css (inside @layer semantic) */
import ErrorPage from "../../utils/ErrorPage";
import About from "../About/About";
import Notification from "../Notification/Notification";
import BeagleChat from "../BeagleChat/BeagleChat";
import LoginComponent from "../Login/LoginComponent";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import { initializeAppParams } from "../../utils/initializeAppParams";
import InsightsDashboard from "../InsightsDashboard/InsightsDashboard";
import Admin from "../Admin/Admin";

initializeAppParams()

const appRouter = createHashRouter([
  {
    path: "/",
    element: <PrivateRoute><LoginComponent /></PrivateRoute>,
    errorElement: <ErrorPage />,
  },
  {
    path: "/beagle-chat",
    element: <PrivateRoute><BeagleChat /></PrivateRoute>,
    children:[
      {
        path:"",
        element:<InsightsDashboard/>
      },
      {
        path:"chat",
        element:<ChatComponent/>
      },
      {
      path:"about",
      element:<About/>
    },
    {
      path:"notification",
      element:<Notification/>
    },
    {
      path:"admin",
      element:<Admin/>
    },
    {
      path:"error",
      element:<ErrorPage/>
    }

  ],
    errorElement: <ErrorPage />,
  },
  {
    path: "/login",
    element: <LoginComponent />,
    errorElement: <ErrorPage />,
  }
]);

// Detect Power BI embed
// const isInPowerBI = window.self !== window.top && document.referrer.includes("powerbi.com");

// // Choose router based on environment
// const router = isInPowerBI
//   ? createHashRouter(routes)
//   : createBrowserRouter(routes);

/**
 * App Module
 * @module App
 */

/**
 * The `App` component serves as the root component of the application.
 * It wraps the application with the Redux `Provider`, passing in the Redux store,
 * and the `RouterProvider`, which provides routing capabilities using `appRouter`.
 */

function App() {
  return (
    <Provider store={store}>
        <RouterProvider router={appRouter} />
    </Provider>
  );
}

export default App;
